
<div class="template-modal__body">
  <div class="template-modal__body-inner">
    <label class="template-modal__body-label">
      <input
        id=""
        type="radio"
        name="radio_tex"
        @click="quote()"
      >
      <i class="fa fa-check-circle" />
    </label>

    <div class="template-modal__body-template">
      <p
        class="template-modal__body-template-title"
        v-html="title"
      />
      <div
        class="template-modal__body-template-text"
        v-html="body"
      />
    </div>
  </div>
</div>
